<template>
    <div class="wrap">
        <div class="title">{{ title }}</div>
        <div class="titleTime">{{ time }}</div>
        <div class="line"></div>
        <div class="paragraph">
            估值区间相对位置是<common-data name="appShortName_37"/>以其原创多因子估值数据构造的另类因子，数值越大表示股价越接近估值区间底部，适用于筛选价格处于估值区间低位的股票。可以结合趋势指标，找到区间位置较好且开始有上涨趋势的股票。
        </div>
        <div class="first">一、策略构建原理</div>
        <div class="paragraph">
            在系统股票池中，运用估值区间相对位置因子精选股价趋近区间底部的股票，同时结合净现比、DMA买入条件等筛选风险低、质地好且处于多头趋势的股票，实现稳健收益。
        </div>
        <div class="first">二、选择因子组合</div>
        <div class="paragraph">1、估值区间相对位置（另类因子）：描述股票当前股价处于估值下限和估值中轨区间相对靠下的位置。</div>
        <div class="paragraph">2、扣非净利润/净利润_TTM（财务类-财务质量）：描述公司利润主要来自主营业务，盈利质量高，可持续性强；</div>
        <div class="paragraph">3、低换手率（量价类-换手率因子）：描述股价上涨前持仓者惜筹惜售态度较一致，成交量相对稳定；</div>
        <div class="paragraph">4、DMA买入条件（量价类-技术指标）：描述股票的多头趋势；</div>
        <div class="paragraph">5、股东数目偏离度（公司资料类-持股结构）：描述股票持股集中度变高，被机构看好。</div>
        <div class="img_center">
            <img class="img" src="./img/图片1.png" />
        </div>
        <div class="paragraph">未引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <img class="img" src="./img/图片2.png" />
        </div>
        <div class="paragraph">引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <img class="img" src="./img/图片3.png" />
        </div>
        <div class="first">三、结论</div>
        <div class="paragraph">
            综上可见，<common-data name="appShortName_37"/>的估值区间相对位置因子，为用户及时提供了更精准的估值水平信息，挖掘出处于估值区间底部的股票，辅之其他因子可以找到有上涨空间的股票，引入多因子估值数据做风险控制，可显著提升策略的表现，从而帮助用户提前占据领先地位、获取更高收益。
        </div>

        <div style="height: 20px"></div>
        <div class="symbolarea">
            <div class="symbol"></div>
            <span class="symboltext">免责说明</span>
        </div>
        <div class="bottom">
            <div class="bottomText">本案例仅用于说明<common-data name="appShortName_37"/>量化功能的使用方法，不构成任何投资建议。</div>
        </div>
        <div style="height: 60px"></div>
    </div>
</template>
<script>
export default {
    props: ["title", "time"], // 接收父组件传递的时间参数
};
</script>
<style scoped src="../common.css"></style>
